import LzYDashboard from '@lz-modules/built-in/Dashboard';
import UserDashboardScreen from './UserDashboardScreen';

const DashboardModule = new LzYDashboard({
    element: <UserDashboardScreen />,
});

export default DashboardModule;
